<template>
  <div class="block">
    <div class="block__inner">
      <input
          :placeholder="placeholder"
          :type="isPasswordVisible"
          :value="modelValue"
          @input="onInput"
          class="block__input"
      >
    </div>
    <p v-if="!validate" class="block__error">{{ errorMessage }}</p>
  </div>
</template>

<script setup>
import {ref} from "vue";

const $emit = defineEmits()
const props = defineProps({
  type: String,
  placeholder: String,
  isError: Boolean,
  error: String,
  modelValue: [String, Number],
  rules: Array
})

const isPasswordVisible = ref(props.type)

const validate = ref(true)
const errorMessage = ref('')
const onInput = (e) => {
  let result = true

  props.rules?.forEach((rule) => {
    result = rule((e.target).value)

    if (result !== true) {
      errorMessage.value = String(result)
      result = false
    }
  })

  validate.value = result

  return $emit('update:modelValue', (e.target).value)
}
</script>

<style lang="scss" scoped>
.block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  position: relative;

  &__inner {
    width: 100%;
    position: relative;
  }

  &__input {
    width: 100%;
    border-radius: 80px;
    border: 1px solid #83839A;
    padding: 18px 25px;
    background-color: transparent;

    color: #83839A;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.72px;

    &::placeholder {
      color: #9797ad;
    }
  }

  &__error {
    color: $error;
    font-size: 12px;
    font-weight: 500;
    animation: fadeInUp 0.3s ease;

    @keyframes fadeInUp {
      0% {
        opacity: 0;
        transform: translateY(-50%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}
</style>